/* eslint-disable import/no-named-as-default */
import { useEffect } from 'react';
import { useNetworkObserver } from 'data-layer-cr/dist/network';
import { REQUEST_CREATE_SIGNATURE } from 'src/store/signature/requestIdentifiers';
import { NetworkIndicator } from 'design-system';
// store & redux
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'src/store/rootReducer';
import {
  requestSignatureCreation,
  resetSignatureStatus,
} from 'src/store/signature/actions';

import SignerLayout from './SignerLayout';

export const DigitalSign = ({
  requestSignatureCreationAction,
  resetSignatureStatusAction,
}: PropsFromRedux): JSX.Element => {
  const requestSignatureStatus = useNetworkObserver(REQUEST_CREATE_SIGNATURE);

  const showRequest = ['initial', 'requesting'].includes(
    requestSignatureStatus,
  );

  useEffect(() => {
    resetSignatureStatusAction();
    requestSignatureCreationAction();
  }, []);

  return (
    <>
      {showRequest && (
        <NetworkIndicator
          data-testid="network-indicator"
          message="Obteniendo datos de solicitud de seguro..."
          requesting={showRequest}
        />
      )}
      {!showRequest && <SignerLayout data-testid="signer-component" />}
    </>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  signatureId: string;
} => ({
  signatureId: state.signature.orderId,
});
const reduxActions = {
  requestSignatureCreationAction: requestSignatureCreation,
  resetSignatureStatusAction: resetSignatureStatus,
};

const connector = connect(mapStateToProps, reduxActions);
type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(DigitalSign);
